import React, { Component } from 'react';

// var imgStyle = {
//   "padding-top": "10px",
// };

export default class Profile extends Component {

  componentWillMount() {
    this.setState({ profile: {} });
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile });
      });
    } else {
      this.setState({ profile: userProfile });
    }
  }

  render() {
      const { profile } = this.state;
    return(
           // <div>
                <li className="navbar-item">
                {/* <img style={imgStyle} src={profile.picture} height="30" alt="profile" />
                </li>
                <li className="navbar-item"> */}
                <a className="nav-link" href="">{profile.name}</a>
                </li>
            // </div>
            )
    }
}


// WEBPACK FOOTER //
// ./src/Profile/Profile.js